module.exports = require("rxjs/observable/empty");